<div *ngIf="!accessToken" class="signup-page">
  <div class="custom-padding">
    <div class="signup-container">
      <div class="flex justify-center title-container">
        <h3>Link is expired !</h3>
      </div>
    </div>
  </div>
</div>

<div class="signup-page" *ngIf="accessToken">
  <div class="custom-padding">
    <div class="signup-container">
      <div class="flex justify-center title-container">
        <img src="/assets/images/Frame4036.png" />
      </div>
      <div class="signup-text text-center">
        <div class="pwd-title">
          {{ "common-keywords.create-your-password" | translate }}
        </div>
        <div class="flex justify-center">
          <div class="pwd-text">
            {{
              "auth.component.password-card.message.set-secure-password"
                | translate
            }}
          </div>
        </div>
      </div>
      <form [formGroup]="fg" (submit)="changePassword()">
        <div class="pwd-input-container">
          <p>
            {{
              "auth.component.password-card.message.enter-new-password"
                | translate
            }}
          </p>
          <ui-password
            class="mt-pwd"
            [feedback]="false"
            formControlName="newPassword"
            type="password"
            [hasError]="
              fg.controls['newPassword'].touched &&
              fg.controls['newPassword'].invalid
            "
          ></ui-password>
          <div class="strength-indicator">
            <div
              class="bar"
              *ngFor="let bar of [1, 1, 1, 1, 1]; let i = index"
              [ngClass]="{
                'active-weak': strength > i && strength <= 2,
                'active-medium': strength > i && strength > 2 && strength <= 4,
                'active-strong': strength > i && strength > 4,
              }"
            ></div>
          </div>
        </div>
        <div>
          <p>
            {{
              "auth.component.password-card.message.re-enter-password"
                | translate
            }}
          </p>
          <ui-password
            class="mt-pwd"
            [feedback]="false"
            formControlName="confirmPassword"
            type="password"
            [hasError]="
              fg.controls['confirmPassword'].touched &&
              fg.controls['confirmPassword'].invalid
            "
          ></ui-password>
        </div>
        <div
          class="flex items-center gap-11 mt-8"
          *ngIf="
            !fg.errors?.['passwordMismatch'] &&
            fg.controls['confirmPassword'].touched
          "
        >
          <ui-icon type="pi-check" [size]="'large'" class="match-img"></ui-icon>
          <span class="match-text">
            {{
              "auth.component.password-card.message.password-match" | translate
            }}
          </span>
        </div>
        <div
          class="flex items-center gap-2 mt-8"
          *ngIf="
            fg.errors?.['passwordMismatch'] &&
            fg.controls['confirmPassword'].touched
          "
        >
          <ui-icon type="au-alert-triangle" class="alert-img"></ui-icon>
          <span class="alert-text">
            {{
              "auth.component.password-card.message.password-not-match"
                | translate
            }}
          </span>
        </div>
        <ui-button
          class="pwd-button"
          buttonType="submit"
          size="large"
          type="black"
          [isDisabled]="fg.invalid || !!(loading$ | async)"
          [loading]="!!(loading$ | async)"
        >
          {{ "common-keywords.create-password" | translate }}
        </ui-button>
      </form>
    </div>
  </div>
</div>
